var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as Sentry from '@sentry/react';
import { Axios } from 'axios';
var config;
export function setup(errorConfig) {
    config = errorConfig;
}
var AppError = /** @class */ (function (_super) {
    __extends(AppError, _super);
    function AppError(err, userMessage, _a) {
        if (userMessage === void 0) { userMessage = ''; }
        var _b = _a === void 0 ? {} : _a, _c = _b.debugMessage, debugMessage = _c === void 0 ? '' : _c, _d = _b.shouldReport, shouldReport = _d === void 0 ? true : _d;
        var _this = this;
        var _e, _f;
        if (!(err instanceof Axios) && !(err instanceof Error) && !(err instanceof AppError)) {
            if (typeof err === "string") {
                err = new Error(err);
                shouldReport = typeof shouldReport != undefined ? shouldReport : false; // Silent error to terminate process
            }
            else {
                throw new Error('Wrong App Error type');
            }
        }
        _this = _super.call(this, userMessage) || this;
        _this.userMsg = '';
        _this.message = ''; // just an alias for userMsg
        _this.handleErr = function (userMessage, shouldReport) {
            var _a, _b, _c;
            _this.userMsg = _this.originalErrMsg;
            _this.isOffline = _this.isNetworkError(_this.err);
            if (_this.isOffline) {
                alert('Oops, something went wrong with your internet connection');
            }
            if (isAxiosErr(_this.err)) {
                _this.userMsg = ((_c = (_b = (_a = _this.err) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) || _this.userMsg;
            }
            _this.userMsg = userMessage || _this.userMsg;
            _this.message = _this.userMsg;
            console.log('---------Debug:---------');
            console.log(_this.debugMsg);
            _this.printLog(_this.err);
            if (_this.isOffline) {
                shouldReport = false;
            }
            if (shouldReport) {
                reportToSentry(_this.err, _this.debugMsg).then(function (r) { return r; });
            }
        };
        /*
          - https://github.com/axios/axios/issues/383
          - https://github.com/axios/axios/pull/1419
        */
        _this.isNetworkError = function (error) { return !!isAxiosErr(error) && !error.response; };
        _this.printLog = function (error) {
            if (isAxiosErr(error)) {
                var axiosResponse = error === null || error === void 0 ? void 0 : error.response;
                if (axiosResponse) {
                    /*
                     * The request was made and the server responded with a
                     * status code that falls out of the range of 2xx
                     */
                    _this.customErrCode = axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.data.statusCode;
                    _this.messageBag = axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.data.errors;
                    _this.contexts = axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.data.fields;
                    _this.statusCode = axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.status;
                    var _a = (axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.config) || {}, url = _a.url, data = _a.data, method = _a.method;
                    var requestInfo = {
                        method: method,
                        url: url,
                        data: data,
                    };
                    console.log('Response headers:');
                    console.log(axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.headers);
                    console.log('Response body:');
                    console.log(axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.data);
                    console.log('Request info:');
                    console.log(requestInfo);
                    Sentry.setExtra('error_header', axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.headers);
                    Sentry.setExtra('error_data', axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.data);
                    Sentry.setExtra('request_info', requestInfo);
                }
                else if (error === null || error === void 0 ? void 0 : error.request) {
                    /*
                     * The request was made but no response was received, `error.request`
                     * is an instance of XMLHttpRequest in the browser and an instance
                     * of http.ClientRequest in Node.js
                     */
                    console.log('Axios requested but no response is returned!');
                    console.log(error.request._response);
                    console.log(error.request);
                    Sentry.setExtra('error_request', error.request);
                    Sentry.setExtra('error_request_response', error.request._response);
                }
            }
            else {
                console.log(error);
                Sentry.setExtra('error', error);
            }
        };
        _this.err = err;
        _this.originalErrMsg = isAxiosErr(_this.err) ? _this.err.message : (_this.err.message || '');
        _this.debugMsg = debugMessage || 'Error!';
        _this.isAxiosErr = isAxiosErr(_this.err);
        _this.customErrCode = null;
        _this.messageBag = null;
        _this.contexts = undefined;
        _this.statusCode = isAxiosErr(_this.err) ? (_f = (_e = _this.err) === null || _e === void 0 ? void 0 : _e.response) === null || _f === void 0 ? void 0 : _f.status : 500;
        _this.handleErr(userMessage, shouldReport);
        _this.isOffline = false;
        return _this;
    }
    return AppError;
}(Error));
export { AppError };
export function reportToSentry(err, debugMsg) {
    var _a;
    if (debugMsg === void 0) { debugMsg = ''; }
    return __awaiter(this, void 0, void 0, function () {
        var user;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!!Sentry.getCurrentHub().getClient()) return [3 /*break*/, 2];
                    return [4 /*yield*/, config.initSentry()];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [4 /*yield*/, ((_a = config.getUser) === null || _a === void 0 ? void 0 : _a.call(config))];
                case 3:
                    user = _b.sent();
                    if (user) {
                        Sentry.setUser(user);
                        Sentry.setTag('email', user === null || user === void 0 ? void 0 : user.email);
                    }
                    Sentry.setExtra('debugMsg', debugMsg);
                    if (config.extraSentryData) {
                        Sentry.setExtra('extra', config.extraSentryData);
                    }
                    Sentry.captureException(err);
                    return [2 /*return*/];
            }
        });
    });
}
function isAxiosErr(anyError) {
    return !!((anyError === null || anyError === void 0 ? void 0 : anyError.response) || (anyError === null || anyError === void 0 ? void 0 : anyError.request));
}
